import { request } from '../request'

// 获取安全域列表
export const getSecurityDomainList = (params: any) =>
  request('/portal/agentClient/area', {
    method: 'GET',
    params,
  })

// 删除安全域
export const deleteSecurityDomain = (ids: string[]) =>
  request(`/portal/agentClient/area`, {
    method: 'DELETE',
    params: { id: ids },
  })

// 获取绑定的钓鱼邮箱列表
export const getBoundPhishingEmailList = (params: any) =>
  request('/portal/agentClient/area/member/bind/phish', {
    method: 'GET',
    params,
  })

// 获取绑定的站点列表
export const getBoundSiteList = (params: any) =>
  request('/portal/agentClient/area/member/bind/site', {
    method: 'GET',
    params,
  })

// 获取绑定的客户端列表
export const getBoundAgentList = (params: any) =>
  request('/portal/agentClient/area/member/bind/agent', {
    method: 'GET',
    params,
  })

// 获取绑定的安全测试邮箱列表
export const getBoundSecurityTestEmailList = (params: any) =>
  request('/portal/agentClient/area/member/bind/agent_email', {
    method: 'GET',
    params,
  })

// 获取钓鱼邮箱列表
export const getPhishingEmailList = params =>
  request('/portal/agentClient/area/member/all/phish', {
    params,
  })

// 获取站点列表
export const getSiteList = params =>
  request('/portal/agentClient/area/member/all/site', {
    params,
  })

// 获取客户端列表
export const getAgentList = params =>
  request('/portal/agentClient/area/member/all/agent', {
    params,
  })

// 获取安全测试邮箱列表
export const getSecurityTestEmailList = params =>
  request('/portal/agentClient/area/member/all/agent_email', {
    params,
  })

// 新增安全域
export const addSecurityDomain = (data: any) =>
  request('/portal/agentClient/area', {
    method: 'POST',
    data,
  })

// 编辑安全域
export const editSecurityDomain = (data: any) =>
  request(`/portal/agentClient/area`, {
    method: 'PUT',
    data,
  })
